import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchSalesOrderLineWeights, setOrderLineWeights, clearSalesOrderLineWeights } from '../../actions/sales_actions';

import SetWeightModal from '../../components/Dispatch/setWeightModal';

const setWeightModal = reduxForm({
  form: 'setWeightModal',
  // validate
})(SetWeightModal);

const selector = formValueSelector('setWeightModal');

function mapStateToProps(state) {
  const totalWeight = selector(state, 'TotalWeight');
  return {
    totalWeight,

    salesOrderLineWeights: state.salesOrders.salesOrderLineWeights,
    salesOrderLineWeightsIsLoading: state.salesOrders.salesOrderLineWeightsIsLoading,
    salesOrderLineWeightsError: state.salesOrders.salesOrderLineWeightsError,

    salesOrderLineWeightsIsEditing: state.salesOrders.salesOrderLineWeightsIsEditing,
    editSalesOrderLineWeightsSuccess: state.salesOrders.editSalesOrderLineWeightsSuccess,
    editSalesOrderLineWeightsError: state.salesOrders.editSalesOrderLineWeightsError,
  };
}

export default connect(mapStateToProps, { fetchSalesOrderLineWeights, setOrderLineWeights, clearSalesOrderLineWeights })(setWeightModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/setWeightModal.jsx